import DgHeader from "./Header";

DgHeader.install = Vue => {
  Vue.component(DgHeader.name, DgHeader);
};

export default DgHeader;
